import { RugbyGameLogTypes } from '../models/rugby-game-log';
import { Locales } from './locales';

export const RugbyGameLogTypeLocalization = {
  [Locales.ru]: {
    [RugbyGameLogTypes.enter_game]: 'Вышел на поле',
    [RugbyGameLogTypes.exit_game]: 'Ушел с поля',
    [RugbyGameLogTypes.try]: 'Попытка',
    [RugbyGameLogTypes.penalty_try]: 'Штрафная попытка',
    [RugbyGameLogTypes.conversion_goal]: 'Реализация',
    [RugbyGameLogTypes.conversion_miss]: 'Реализация промах',
    [RugbyGameLogTypes.penalty_miss]: 'Штрафной промах',
    [RugbyGameLogTypes.penalty_goal]: 'Штрафной гол',
    [RugbyGameLogTypes.penalty_kick_to_touch]: 'Штрафной в аут',
    [RugbyGameLogTypes.tap_penalty]: 'Штрафной разыгран',
    [RugbyGameLogTypes.drop_goal]: 'Дроп-гол',
    [RugbyGameLogTypes.drop_goal_miss]: 'Дроп-гол промах',
    [RugbyGameLogTypes.free_kick]: 'Свободный удар',
    [RugbyGameLogTypes.foul]: 'Фол',
    [RugbyGameLogTypes.yellow_card]: 'Желтая карточка',
    [RugbyGameLogTypes.red_card]: 'Красная карточка',
    [RugbyGameLogTypes.red_card_20]: 'Красная карточка (20 мин.)',
    [RugbyGameLogTypes.offload]: 'Скидка при завхвате',
    [RugbyGameLogTypes.tackle]: 'Успешный захват',
    [RugbyGameLogTypes.handling_error]: 'Ошибка приема',
    [RugbyGameLogTypes.carries_over_gainline]: 'Прорыв линии',
    [RugbyGameLogTypes.bleeding_injury]: 'Кровоточащая травма',
    [RugbyGameLogTypes.head_injury]: 'Травма головы',
    [RugbyGameLogTypes.end_game_penalty_miss]: 'Штрафной промах',
    [RugbyGameLogTypes.end_game_penalty_goal]: 'Штрафной гол',
    [RugbyGameLogTypes.foot_field_shot]: 'Удар ногой в поле',
    [RugbyGameLogTypes.foot_out_shot]: 'Удар ногой в аут',
    [RugbyGameLogTypes.foot_kick_50_22]: 'Удар ногой 50/22',
    [RugbyGameLogTypes.run]: 'Забег',
    [RugbyGameLogTypes.timeout]: 'Таймаут',
    [RugbyGameLogTypes.scrum_won]: 'Схватка выиграна',
    [RugbyGameLogTypes.scrum_lost]: 'Схватка проиграна',
    [RugbyGameLogTypes.scrum_won_free]: 'Схватка выиграна без сопротивления',
    [RugbyGameLogTypes.lineout_won]: 'Коридор выигран',
    [RugbyGameLogTypes.lineout_lost]: 'Коридор проигран',
    [RugbyGameLogTypes.quick_throw]: 'Быстрый вброс',
    [RugbyGameLogTypes.ruck_won]: 'Рак выигран',
    [RugbyGameLogTypes.ruck_lost]: 'Рак проигран',
    [RugbyGameLogTypes.maul_won]: 'Мол выигран',
    [RugbyGameLogTypes.maul_lost]: 'Мол проигран',
    [RugbyGameLogTypes.team_foul]: 'Нарушение',
    [RugbyGameLogTypes.start_kick]: 'Начальный удар',
    [RugbyGameLogTypes.twenty_two_meters_kick]: 'Удар с 22 метров',
    [RugbyGameLogTypes.goal_kick]: 'Удар от ворот',
    [RugbyGameLogTypes.out]: 'Аут',
  },
  [Locales.en]: {
    [RugbyGameLogTypes.enter_game]: 'Entering the court',
    [RugbyGameLogTypes.exit_game]: 'Exit the court',
    [RugbyGameLogTypes.try]: 'Attempt',
    [RugbyGameLogTypes.penalty_try]: 'Penalty attempt',
    [RugbyGameLogTypes.conversion_goal]: 'Touchdown',
    [RugbyGameLogTypes.conversion_miss]: 'Touchdown miss',
    [RugbyGameLogTypes.penalty_miss]: 'Penalty kick miss',
    [RugbyGameLogTypes.penalty_goal]: 'Penalty goal',
    [RugbyGameLogTypes.penalty_kick_to_touch]: 'Penalty kick to out',
    [RugbyGameLogTypes.tap_penalty]: 'Penalty has been played',
    [RugbyGameLogTypes.drop_goal]: 'Drop goal',
    [RugbyGameLogTypes.drop_goal_miss]: 'Drop goal miss',
    [RugbyGameLogTypes.free_kick]: 'Free kick',
    [RugbyGameLogTypes.foul]: 'Foul',
    [RugbyGameLogTypes.yellow_card]: 'Yellow card',
    [RugbyGameLogTypes.red_card]: 'Red card',
    [RugbyGameLogTypes.red_card_20]: 'Red card (20 min.)',
    [RugbyGameLogTypes.offload]: 'Offload',
    [RugbyGameLogTypes.tackle]: 'Successful tackle',
    [RugbyGameLogTypes.handling_error]: 'Error receiving',
    [RugbyGameLogTypes.carries_over_gainline]: 'Line breakout',
    [RugbyGameLogTypes.bleeding_injury]: 'Bleeding injury',
    [RugbyGameLogTypes.head_injury]: 'Head injury',
    [RugbyGameLogTypes.end_game_penalty_miss]: 'Penalty miss',
    [RugbyGameLogTypes.end_game_penalty_goal]: 'Penalty goal',
    [RugbyGameLogTypes.foot_field_shot]: 'Foot field shot',
    [RugbyGameLogTypes.foot_out_shot]: 'Kick out of bounds',
    [RugbyGameLogTypes.foot_kick_50_22]: 'Foot kick 50/22',
    [RugbyGameLogTypes.run]: 'Run',
    [RugbyGameLogTypes.timeout]: 'Timeout',
    [RugbyGameLogTypes.scrum_won]: 'Scrum is won',
    [RugbyGameLogTypes.scrum_lost]: 'Scrum is lost',
    [RugbyGameLogTypes.scrum_won_free]: 'Scrum was won without resistance',
    [RugbyGameLogTypes.lineout_won]: 'Lineout was won',
    [RugbyGameLogTypes.lineout_lost]: 'Lineout was lost',
    [RugbyGameLogTypes.quick_throw]: 'Quick throw',
    [RugbyGameLogTypes.ruck_won]: 'Ruck won',
    [RugbyGameLogTypes.ruck_lost]: 'Ruck lost',
    [RugbyGameLogTypes.maul_won]: 'Maul won',
    [RugbyGameLogTypes.maul_lost]: 'Maul lost',
    [RugbyGameLogTypes.team_foul]: 'Foul',
    [RugbyGameLogTypes.start_kick]: 'Start kick',
    [RugbyGameLogTypes.twenty_two_meters_kick]: '22 metres kick',
    [RugbyGameLogTypes.goal_kick]: 'Удар от ворот',
    [RugbyGameLogTypes.out]: 'Out',
  }
};
